export default __webpack_public_path__ + "media/images/no-access-illustration-bf59ebe2.png";